var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-xs text-blue-600 font-bold cursor-pointer underline",attrs:{"title":_vm.BUTTONS_VALUES.get_sms_status},on:{"click":function($event){return _vm.onStatus({id: _vm.id})}}},[_vm._v(_vm._s(_vm.id))])
}
var staticRenderFns = []

export { render, staticRenderFns }